import React from 'react';
import { Sparkles, X } from 'lucide-react';

/**
 * Modale per la generazione AI di un preventivo a partire da una descrizione testuale.
 * Lo stato è gestito completamente dal parent (PreventiviPage).
 */
export default function PreventivoAIGenModal({
  cataloghi,
  selectedCatalogo,
  onSelectCatalogo,
  aiDesc,
  onChangeDesc,
  aiLoading,
  aiProgress,
  onSubmit,
  onClose,
}) {
  return (
    <div className="fixed inset-0 bg-black/60 flex items-end sm:items-center justify-center z-50 p-0 sm:p-4">
      <div className="bg-white rounded-t-2xl sm:rounded-lg w-full sm:max-w-5xl max-h-[92vh] sm:max-h-[88vh] overflow-y-auto animate-scale-in shadow-2xl">
        <div className="bg-gradient-to-r from-primary to-amber-50 px-6 py-5 border-b border-slate-200 flex items-start justify-between">
          <div className="flex items-start gap-3">
            <div className="w-11 h-11 rounded-lg bg-primary text-white flex items-center justify-center flex-shrink-0">
              <Sparkles size={22} />
            </div>
            <div>
              <h3 className="text-2xl font-extrabold text-slate-900">Genera Preventivo con AI</h3>
              <p className="text-sm text-slate-600 mt-0.5">Descrivi il lavoro e l'AI generera una bozza basata sul prezzario selezionato</p>
            </div>
          </div>
          <button onClick={onClose} className="p-2 hover:bg-white/50 rounded-md transition-colors">
            <X size={22} className="text-slate-500" />
          </button>
        </div>

        <div className="px-6 py-5 space-y-5">
          {cataloghi.length > 1 && (
            <div data-testid="ai-catalogo-switcher">
              <label className="text-xs font-bold text-slate-700 uppercase tracking-wider block mb-2">Prezzario di riferimento</label>
              <div className="flex flex-wrap gap-2">
                {cataloghi.map(c => (
                  <button key={c.id} type="button" onClick={() => onSelectCatalogo(c.id)}
                    className={`text-sm px-4 py-2 rounded-md font-bold transition-all ${selectedCatalogo === c.id
                      ? (c.id === 'cer_2025' ? 'bg-indigo-600 text-white shadow-md' : c.id === 'aziendale' ? 'bg-green-600 text-white shadow-md' : 'bg-blue-600 text-white shadow-md')
                      : 'bg-slate-100 text-slate-700 hover:bg-slate-200'}`}>
                    {c.id === 'cer_2025' ? 'CER 2025' : c.id === 'lombardia_2025' ? 'Lombardia 2025' : c.nome}
                  </button>
                ))}
              </div>
            </div>
          )}

          <div>
            <label className="text-xs font-bold text-slate-700 uppercase tracking-wider block mb-2">Descrizione lavorazione</label>
            <textarea data-testid="ai-description"
              placeholder="Es: Ristrutturazione bagno completo 8mq con demolizione pavimento e rivestimenti, sostituzione sanitari, nuovi rivestimenti gres porcellanato, tinteggiatura finale..."
              rows={7}
              className="w-full px-4 py-3 border border-slate-300 rounded-md text-base leading-relaxed focus:ring-2 focus:ring-primary/30 focus:border-primary resize-none"
              value={aiDesc} onChange={e => onChangeDesc(e.target.value)} />
            <p className="text-xs text-slate-500 mt-1.5">Suggerimento: piu sei specifico (mq, materiali, lavorazioni) piu accurato sara il preventivo</p>
          </div>

          <button data-testid="ai-submit" onClick={onSubmit} disabled={aiLoading || !aiDesc.trim()}
            className="w-full py-3.5 bg-primary text-white font-bold text-base rounded-md hover:bg-primary-hover transition-all active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 shadow-md">
            {aiLoading ? <><div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"/>{aiProgress || 'Generazione...'}</> : <><Sparkles size={20} /> Genera Preventivo</>}
          </button>
          {aiLoading && (
            <div className="bg-blue-50 border border-blue-200 rounded-md p-3 text-center" data-testid="ai-progress-text">
              <p className="text-sm text-blue-900 font-medium">L'AI sta lavorando...</p>
              <p className="text-xs text-blue-700 mt-0.5">Puo richiedere fino a 2 minuti per un preventivo dettagliato. Il job continua anche se chiudi la finestra.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
